import opIs from '@opsbase/lib-op/helpers/opIs';
import useOpFindById from '@opsbase/react-gql-hooks/op/useOpFindById';
import useOpStartScheduled from '@opsbase/react-gql-hooks/op/useOpStartScheduled';
import useOpDefinitionAssign from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionAssign';
import useParams from '@opsbase/web-nav/useParams';
import React, { useCallback, useEffect, useState } from 'react';
import OpPerformProcessDialog from './OpPerformProcessDialog';
import OpPerformStartDialog from './OpPerformStartDialog';
export function OpPerformDialog() {
    const { id } = useParams();
    const userWantsToPerformAnOnDemandOp = id === 'ondemand';
    const [opToPerform, setOpToPerform] = useState();
    const [startingOp, setStartingOp] = useState(false);
    const assignOpDefinition = useOpDefinitionAssign();
    const startScheduled = useOpStartScheduled();
    const { loading: loadingOp, data: loadedOp } = useOpFindById({
        variables: { id },
        skip: userWantsToPerformAnOnDemandOp,
    });
    useEffect(() => {
        if ((opIs.started(loadedOp) || opIs.submitted(loadedOp)) && !opToPerform)
            setOpToPerform(loadedOp);
    }, [loadedOp, opToPerform]);
    const handleStartOp = useCallback(async (opDefinitionId, placeId, title, completeBy) => {
        setStartingOp(true);
        if (userWantsToPerformAnOnDemandOp) {
            const ops = await assignOpDefinition({
                id: opDefinitionId,
                placeId,
                title,
                completeBy,
                assignAndStart: true,
            });
            setOpToPerform(ops === null || ops === void 0 ? void 0 : ops[0]);
        }
        else {
            setOpToPerform(await startScheduled({
                id,
                title: title,
            }));
        }
        setStartingOp(false);
    }, [id, assignOpDefinition, startScheduled, userWantsToPerformAnOnDemandOp]);
    if (loadingOp)
        return null;
    if (!opToPerform) {
        return (React.createElement(OpPerformStartDialog, { ondemand: userWantsToPerformAnOnDemandOp, loading: startingOp, op: loadedOp, onStart: handleStartOp }));
    }
    if (!opIs.performable(opToPerform))
        return null;
    return React.createElement(OpPerformProcessDialog, { op: opToPerform });
}
export default OpPerformDialog;
